/// <reference path="../Story/StoryGrid.ts"/>
namespace PaperTrail.NewsletterControl {

    import fld = StoryRow.Fields;

    @Serenity.Decorators.registerClass()
    export class NewsletterStoriesGrid extends StoryGrid {
        protected getDialogType() { return NewsletterStoriesDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        //protected getColumns(): Slick.Column[] {
        //    return super.getColumns().filter(x => x.field !== fld.CustomerCompanyName);
        //}

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }
         
        protected addButtonClick() {
            this.editItem({ NewsletterId: this.newsletterID });
        }
         
        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.newsletterID;
        }


        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();

            columns.forEach(col => col.cssClass += " col-allowBackground");
            //columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            //columns.unshift({
            //    field: 'View Details',
            //    name: '',
            //    format: ctx => '<a class="inline-action view-details" title="view details"></a>',
            //    width: 30,
            //    minWidth: 30,
            //    maxWidth: 30,
            //    sortable: false,
            //    resizable: false
            //});
            //columns.splice(1, 0, {
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 30,
            //    minWidth: 30,
            //    maxWidth: 30,
            //    sortable: false,
            //    resizable: false
            //});
            columns.unshift({
                field: 'Read Story',
                name: '',
                format: ctx => '<a class="inline-action read-story" title="Read Story">' +
                    '<i class="fa fa-glasses"></i> Read Story</a>',
                width: 110,
                minWidth: 110,
                maxWidth: 110,
                sortable: false,
                resizable: false
            });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            let self = this;

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row) as StoryRow;

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('view-details')) {
                    this.editItem(item.NewsletterId);
                }
                else if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {
                        NewsletterService.Delete({
                            EntityId: item.NewsletterId,
                        }, response => {
                            this.refresh();
                        });
                    });
                }
                else if (target.hasClass('read-story')) {

                    var sdlg = new NewsletterControl.StoryContributorDialog();
                    this.initDialog(sdlg);
                    sdlg.loadEntityAndOpenDialog(item);
                }
            }
        }

        private _newsletterID: number[];

        get newsletterID() {
            return this._newsletterID;
        }

        set newsletterID(value: number[]) {
            if (this._newsletterID !== value) {
                this._newsletterID = value;
                this.setEquality('NewslettersList', value);

                if (!Q.Authorization.hasPermission(PermissionKeys.Organizer)) { 
                    var userId = Administration.UserRow.getLookup().items
                        .filter(x => x.Username === Q.Authorization.username)[0].UserId;
                    this.setEquality('UserId', userId);
                }
                this.refresh();
            }
        }
    }
}